export const COMPARE = 0;
export const SWAP = 1;
export const FINISH = 2;
export const UPDATE = 3;
